// removed by extract-text-webpack-plugin
module.exports = {"Table":"_9zKjI","TableSimple":"_1BuLh"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/components/Table.css
// module id = 466
// module chunks = 3 4 5